import angular from 'angular';
import settingsSidebarComponent from './settings-sidebar.component';


let settingsSidebarModule = angular.module('settingsSidebar', [

])

.component('settingsSidebar', settingsSidebarComponent);

export default settingsSidebarModule;



// WEBPACK FOOTER //
// ./client/common/settings-sidebar/settings-sidebar.js